import { useEffect } from "react"


const TestToAds = () => {
    useEffect(() => {
        setTimeout(() => {
            window.location.href = "alipays://platformapi/startapp?appId=2021005151656223&page=%2Fpages%2Findex%2Findex&query=channelInfo%3D%257B%2522channel%2522%253A%2522mini_app%2522%252C%2522subChannel%2522%253A%2522miniapp.alipay%2522%252C%2522subSubChannel%2522%253A%2522miniapp.alipay.et%2522%257D%26alsc_exsrc%3DES0007265508%26scene%3D0c9d072d5d494395bac9f3ac1587dc9b"
        }, 100)
    }, [])

    return (<div style={{width: "100%", height: "100%", background: "#FFF",}}> </div>)
}

export default TestToAds;